module.exports = __webpack_public_path__ + "img/安全可靠.4a158ceb.png";